// extracted by mini-css-extract-plugin
export default {"modal":"SettingModal_modal__6AgFS","icons":"SettingModal_icons__6o+sd"};